module.exports = __webpack_public_path__ + "676fe6757fb4ecb3cda10f93188fea46.glb";